<template>
  <!-- Table Container Card -->
  <b-card>
    <validation-observer ref="cbnReportRules">
      <b-form @submit.prevent="handleSubmit">
        <b-row class="match-height">
          <!-- Reporting Date-->
          <b-col md="5">
            <DatePickerField
              id="reporting-date"
              v-model="cbnReportFormData.reportingDate"
              rules="required"
              :min-date="new Date()"
              :label="$t('Reporting Date')"
              :error-name="$t('Reporting Date')"
              :config="datePickerConfig"
              :placeholder="$t('Select Date')"
            />
          </b-col>
          <!--  Reporting Date -->

          <b-col
            md="4"
            class="mt-2"
          >
            <Button
              :label="$t('Generate Report')"
              :loading="isLoading"
              :disabled="isDisabled"
              variant="primary"
              size="md"
              @click="handleSubmit"
            />
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BForm, BCol,
} from 'bootstrap-vue'
import { tableMixins } from '@core/mixins/table'
import { modalMixins } from '@core/mixins/modal'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import { mapActions, mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import {
  toYearWithDate, toCustomDate, getDate,
} from '@/helpers/formatDate'
import { toBalance, formatAmount, toFormatAmount } from '@/helpers/formatAmount'
import 'jspdf-autotable'
import DatePickerField from '../../../forms/DatePickerField.vue'
import Button from '../../../components/button/Button.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    Button,
    DatePickerField,
    ValidationObserver,
    FullScreenSpinner,
  },
  directives: {
    Ripple,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      toBalance,
      toFormatAmount,
      isBusy: false,
      isDisabledText: false,
      required,
      isLoading: false,
      isDisabled: false,
      showSpinner: false,
      cbnReportFormData: {
        reportingDate: null,
      },
      datePickerConfig: {
        dateFormat: 'd/m/Y',
        maxDate: '',
        defaultDate: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      corporateDetails: 'operations/getCorporateDetails',
      currentFinancialDate: 'operations/getCurrentFinancialDate',
    }),
    getInstitutionFinancialDate() {
      return getDate(this.currentFinancialDate.financialDate)
    },
  },
  mounted() {
    this.datePickerConfig.maxDate = this.getInstitutionFinancialDate
  },
  methods: {
    ...mapActions({
      downloadCBNReport: 'reports/downloadCBNReport',
    }),
    handleSubmit() {
      this.$refs.cbnReportRules.validate().then(async success => {
        if (success) {
          this.exportCBNReport()
        }
      })
    },
    async exportCBNReport() {
      try {
        this.isBusy = true
        this.showSpinner = true
        const response = await this.downloadCBNReport({
          reportingDate: this.cbnReportFormData.reportingDate ? toYearWithDate(this.cbnReportFormData.reportingDate) : null,
        })
        if (response.status === 200) {
          this.alertSuccessCustom({
            text: 'Your download is in progress and might take a little longer. Go to your',
            link: {
              text: 'Download Manager',
              route: { name: 'download-manager' },
            },
            afterLinkText: ' to access the completed file.',
          })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isBusy = false
        this.showSpinner = false
      }
    },
    formatCustomDate: toCustomDate,
    toAmount: formatAmount,
  },
}
</script>

<style lang="scss">
   @import '@core/scss/vue/libs/vue-select.scss';
</style>
